module.exports = __webpack_public_path__ + "fonts/Manrope-800-latin-ext29.4e3c84a.woff2";